module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/PANS-LABYRINTH.6f324ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/PANS-LABYRINTH.jpg
// module id = ODNj
// module chunks = 0